/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WorkspaceWorkspaceIdRouteImport } from './routes/workspace.$workspaceId'
import { Route as WorkspaceWorkspaceIdAgentsRouteImport } from './routes/workspace.$workspaceId.agents'
import { Route as WorkspaceWorkspaceIdCanvasSessionIdRouteImport } from './routes/workspace.$workspaceId.canvas.$sessionId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceWorkspaceIdRoute = WorkspaceWorkspaceIdRouteImport.update({
  id: '/workspace/$workspaceId',
  path: '/workspace/$workspaceId',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceWorkspaceIdAgentsRoute =
  WorkspaceWorkspaceIdAgentsRouteImport.update({
    id: '/agents',
    path: '/agents',
    getParentRoute: () => WorkspaceWorkspaceIdRoute,
  } as any)
const WorkspaceWorkspaceIdCanvasSessionIdRoute =
  WorkspaceWorkspaceIdCanvasSessionIdRouteImport.update({
    id: '/canvas/$sessionId',
    path: '/canvas/$sessionId',
    getParentRoute: () => WorkspaceWorkspaceIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/workspace/$workspaceId': typeof WorkspaceWorkspaceIdRouteWithChildren
  '/workspace/$workspaceId/agents': typeof WorkspaceWorkspaceIdAgentsRoute
  '/workspace/$workspaceId/canvas/$sessionId': typeof WorkspaceWorkspaceIdCanvasSessionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/workspace/$workspaceId': typeof WorkspaceWorkspaceIdRouteWithChildren
  '/workspace/$workspaceId/agents': typeof WorkspaceWorkspaceIdAgentsRoute
  '/workspace/$workspaceId/canvas/$sessionId': typeof WorkspaceWorkspaceIdCanvasSessionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/workspace/$workspaceId': typeof WorkspaceWorkspaceIdRouteWithChildren
  '/workspace/$workspaceId/agents': typeof WorkspaceWorkspaceIdAgentsRoute
  '/workspace/$workspaceId/canvas/$sessionId': typeof WorkspaceWorkspaceIdCanvasSessionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/workspace/$workspaceId'
    | '/workspace/$workspaceId/agents'
    | '/workspace/$workspaceId/canvas/$sessionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/workspace/$workspaceId'
    | '/workspace/$workspaceId/agents'
    | '/workspace/$workspaceId/canvas/$sessionId'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/workspace/$workspaceId'
    | '/workspace/$workspaceId/agents'
    | '/workspace/$workspaceId/canvas/$sessionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  WorkspaceWorkspaceIdRoute: typeof WorkspaceWorkspaceIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId': {
      id: '/workspace/$workspaceId'
      path: '/workspace/$workspaceId'
      fullPath: '/workspace/$workspaceId'
      preLoaderRoute: typeof WorkspaceWorkspaceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/agents': {
      id: '/workspace/$workspaceId/agents'
      path: '/agents'
      fullPath: '/workspace/$workspaceId/agents'
      preLoaderRoute: typeof WorkspaceWorkspaceIdAgentsRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdRoute
    }
    '/workspace/$workspaceId/canvas/$sessionId': {
      id: '/workspace/$workspaceId/canvas/$sessionId'
      path: '/canvas/$sessionId'
      fullPath: '/workspace/$workspaceId/canvas/$sessionId'
      preLoaderRoute: typeof WorkspaceWorkspaceIdCanvasSessionIdRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdRoute
    }
  }
}

interface WorkspaceWorkspaceIdRouteChildren {
  WorkspaceWorkspaceIdAgentsRoute: typeof WorkspaceWorkspaceIdAgentsRoute
  WorkspaceWorkspaceIdCanvasSessionIdRoute: typeof WorkspaceWorkspaceIdCanvasSessionIdRoute
}

const WorkspaceWorkspaceIdRouteChildren: WorkspaceWorkspaceIdRouteChildren = {
  WorkspaceWorkspaceIdAgentsRoute: WorkspaceWorkspaceIdAgentsRoute,
  WorkspaceWorkspaceIdCanvasSessionIdRoute:
    WorkspaceWorkspaceIdCanvasSessionIdRoute,
}

const WorkspaceWorkspaceIdRouteWithChildren =
  WorkspaceWorkspaceIdRoute._addFileChildren(WorkspaceWorkspaceIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  WorkspaceWorkspaceIdRoute: WorkspaceWorkspaceIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
